import { Box, styled, Typography } from '@mui/material';
import { MfaResetTone } from './types';

export const MfaResetContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '32px',
});

export const MfaResetStatusText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'tone',
})<{ tone: MfaResetTone }>(({ theme, tone }) => ({
  fontSize: 12,
  maxWidth: '260px',
  color: {
    neutral: theme.palette.secondary.main,
    error: theme.palette.error.main,
    success: theme.palette.primary.main,
  }[tone],
}));
